// Module
var code = "<div class=\"page-reload\" aria-label=\"Carregando...\"> <div class=\"page-reload__header\"> <div class=\"page-reload__header__logo\"></div> </div> <div class=\"spinner\"></div> </div> ";
// Exports
module.exports = code;